<template>
  <div>
    <sys-data-table
      v-model="produtos_selecionados"
      :height="alturaDaJanela - 210"
      :item-height="45"
      :headers="CABECALHOS"
      :items="produtos"
      :search="pesquisa"
      show-select
      item-key="index_row"
      :loading="carregando_dados"
      :item-class="classesCssLinha"
    >
      <template #top>
        <TopoGrid v-model="pesquisa" class="pt-2 pb-2" :pedido_selecionado="PEDIDO_SELECIONADO">
          <template #append-left>
            <v-badge v-if="!PEDIDO_SELECIONADO.pedido_produtos_combinados && produtos_selecionados.length > 0" overlap color="white">
              <v-btn small dark color="#013254" class="ml-3" @click="dialog_ajuste_pedido = true">
                ajustar pedido
              </v-btn>

              <template #badge>
                <span v-text="produtos_selecionados.length" class="text-black" />
              </template>
            </v-badge>

            <v-badge v-if="produtos_selecionados.length > 0" overlap color="white">
              <v-btn small dark color="red" class="ml-3" @click="excluirProdutos(produtos_selecionados)">
                <v-icon class="mr-1" size="18">mdi-delete</v-icon>
                excluir
              </v-btn>

              <template #badge>
                <span v-text="produtos_selecionados.length" class="text-black" />
              </template>
            </v-badge>
          </template>
        </TopoGrid>

        <GerenciaHeaders v-model="cabecalhos" />
      </template>

      <template #item.sugerido="{value}">{{ formatarNumero(value) }}</template>

      <template #item.preco_liquido_total="{item}">
        {{ formatarDinheiro(Number(item.valor_liquido || 0) * Number(item.qtde_pedido || 0)) }}
      </template>

      <template #item.preco_custo_base="{item}">
        <FormatarMoeda :tipo="item.moeda" />
        {{ Helpers.formatarValorComCasas(item.preco_custo_base, 4) }}
      </template>

      <template #item.total="{ item }">
        <FormatarMoeda :tipo="item.moeda" />
        {{ Helpers.formatarValorComCasas(totalLinha(item), 4) }}
      </template>

      <template #item.indicador="{item}">
        <div>
          <v-icon v-if="custoVsBase(item) === 0" class="ml-5">mdi-arrow-left-right</v-icon>

          <v-chip v-else small>
            <div class="ml-n1">
              <v-icon v-if="custoVsBase(item) > 0" color="red" size="14">mdi-arrow-up</v-icon>
              <v-icon v-else-if="custoVsBase(item) < 0" color="green" size="14">mdi-arrow-down</v-icon>
            </div>
            {{ Math.abs(custoVsBase(item)) < 999 ? Helpers.formatarValor(Math.abs(custoVsBase(item))) : "999+" }}
          </v-chip>
        </div>
      </template>

      <template #item.descricao_produto="{item}">
        <div class="d-flex align-center">
          <DetalhesProduto
            v-if="item.idproduto"
            :produto="{ id_grupo: item.grupo, id_filial: item.filial, id_produto: item.idproduto, produto_eh_combinacao: PEDIDO_SELECIONADO.pedido_produtos_combinados}"
            class="ml-n3"
          />
          <span v-text="item.descricao_produto" class="ml-n1" />
        </div>
      </template>

      <template #item.data_ultima_requisicao="{ item }">
        <span v-if="item.data_ultima_requisicao">
          {{ item.data_ultima_requisicao.split('-').reverse().join('/') }}
        </span>
      </template>

      <template #item.data_ultima_entrada="{ item }">
        <span v-if="item.data_ultima_entrada">
          {{ item.data_ultima_entrada.split('-').reverse().join('/') }}
        </span>
      </template>

      <template v-slot:item.peso="{ item }">{{ Helpers.formatarValor(item.peso * item.qtde_pedido) }}</template>

      <template v-slot:item.cubagem="{ item }">
        {{ Helpers.formatarValor((item.altura * item.comprimento * item.largura) * item.qtde_pedido) }}
      </template>

      <template #item.classificacao_rentabilidade="{value}">
        {{ value }}
      </template>

      <template #item.classificacao_criticidade="{value}">
        <template v-if="value === 'Z'">A</template>
        <template v-else-if="value === 'Y'">B</template>
        <template v-else>C</template>
      </template>

      <template #item.qtde_pedido="{item}">
        <QuantidadeProduto class="w-110" :pedido_selecionado="PEDIDO_SELECIONADO" :produto="item" />
      </template>

      <template #item.preco_custo="{item}">
        <PrecoCustoProduto
          class="w-110"
          :pedido_selecionado="PEDIDO_SELECIONADO"
          :produto="item"
          :prefix="Helpers.formatarMoeda(item.moeda)"
        />
      </template>

      <template v-slot:item.estoque="{ item }">
        {{ Helpers.formatarValorComCasas(item.estoque,0) }}
      </template>

      <template v-slot:item.lastro_palete="{ item }">
        {{ Helpers.formatarValor(item.lastro_palete) }}
      </template>

      <template v-slot:item.altura_palete="{ item }">
        {{ Helpers.formatarValor(item.altura_palete) }}
      </template>

      <template v-slot:item.qt_total_palete="{ item }">
        {{ Helpers.formatarValor(Number(item.lastro_palete) * Number(item.altura_palete)) }}
      </template>

      <template v-slot:item.compra_em_palete="{ item }">
        <CompraEmPalete
          :lastro_palete="Number(item.lastro_palete)"
          :altura_palete="Number(item.altura_palete)"
          :quantidade_compra="Number(item.qtde_pedido)"
          :unidade_compra="item.unidade_compra"
        />
      </template>

      <template #item.cobertura_estoque_futura="{item}">
        <CalculaCoberturaEstoqueFutura :item="{...item, sugestao: item.qtde_pedido}" />
      </template>

      <template #item.action="{item}">
        <div class="d-flex align-center">
          <v-spacer />

          <template v-if="item.exportado === 'N' && PEDIDO_SELECIONADO.pedido_cli != 0">
            <v-tooltip top :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="orange" v-bind="attrs" v-on="on" @click="abrirDialogExportacaoPedidoERP">
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span v-text="'Alteração não exportada para o ERP'" />
            </v-tooltip>
          </template>

          <v-btn icon @click="excluirProdutos([item])">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:footer.prepend>
        <div style="display: flex; color: #555;">
          <h4 class="pl-3">
            Total Peso (Kg):&nbsp;
            {{ Helpers.formatarValorComCasas(GET_TOTAL_PESO, 4) }}
          </h4>
          <h4 class="pl-10">
            Total Cubagem (M³):&nbsp;
            {{ Helpers.formatarValorComCasas(GET_TOTAL_CUBAGEM, 4) }}
          </h4>
          <h4 class="pl-10">
            Total Preço Líquido:&nbsp;
            {{ Helpers.formatarValorMonetario(GET_TOTAL_PRECO_LIQUIDO) }}
          </h4>
          <h4 v-if="CONFIG_FORNECEDOR.calcular_litragem" class="pl-10">
            Total sugestão em {{ CONFIG_FORNECEDOR.tipo_litragem === 'LT' ? 'litro' : 'galão' }}:&nbsp;
            {{ Helpers.formatarValorComCasas(TOTAL_SUGESTAO_EM_GALAO) }}
          </h4>
          <h4 class="pl-10">
            Compra em pallet:&nbsp;
            <template v-if="Number(COMPRA_EM_PALLET_COMPUTED.qt_camandas) > 0">
              {{ Helpers.formatarValorComCasas(COMPRA_EM_PALLET_COMPUTED.qt_camandas) }} cam.
              |
              <template v-if="Number(COMPRA_EM_PALLET_COMPUTED.qt_pallet) > 0">
                {{ Helpers.formatarValorComCasas(COMPRA_EM_PALLET_COMPUTED.qt_pallet) }} pallet
              </template>
              <template v-else>-</template>
            </template>
            <template v-else>-</template>
          </h4>
        </div>
      </template>
    </sys-data-table>

    <DialogAjustePedido
      v-model="dialog_ajuste_pedido"
      :idpedido="PEDIDO_SELECIONADO.idpedido"
      :filial_pedido="PEDIDO_SELECIONADO.filial_compra"
      :idprodutos="produtos_selecionados.map((i) => i.idproduto)"
      :fornecedores="[PEDIDO_SELECIONADO.idfornecedor]"
      :descricao_fornecedor="PEDIDO_SELECIONADO.nome_fornecedor || ''"
      tipo_compra="CP"
      :filtros_gerais_inicial="{
        linhas: FILTROS.linhas,
      }"
      @atualizar-pedido="atualizarCarrinhoAjustePedido"
    />
  </div>
</template>

<script>
import { calcular_sugestao_em_galao } from "@/components/compra/fornecedor/GalonagemProduto/CalcularSugestaoEmGalao";
import { buscarProdutosPedidoSelecionado, exluirProdutoDoCarrinho } from "@/api/compraPorProdutosGerais/Carrinho";
import { cabecalhos } from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/Cabecalhos";
import { pedidos_mixin } from "@/components/compra/ProdutosGerais/Carrinho/PedidosMixin";
import { arrayColumn, formatarValor, formatarValorMonetario, logout } from "@/helpers";
import { info_pedido_geral } from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import { mapGetters } from "vuex";

import QuantidadeProduto from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/QuantidadeProduto";
import PrecoCustoProduto from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/PrecoCustoProduto";
import CalculaCoberturaEstoqueFutura from "@/components/compra/CalculaCoberturaEstoqueFutura";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import TopoGrid from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/TopoGrid";
import GerenciaHeaders from "@/components/compra/carrinho/GerenciaHeaders.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index";
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";
import DialogAjustePedido from "@/components/compra/ProdutosGerais/Carrinho/Meta/Index.vue";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import CompraEmPalete from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/CompraEmPalete.vue";

export default {
  name: "GridCarrinhoCompraProdutosGerais",
  components: {
    CompraEmPalete,
    CalculaCoberturaEstoqueFutura,
    TopoGrid,
    QuantidadeProduto,
    PrecoCustoProduto,
    DetalhesProduto,
    FormatarMoeda,
    GerenciaHeaders,
    TextFieldFormatadorDeValor,
    DialogAjustePedido
  },
  mixins: [pedidos_mixin, ResponsiveHeight],
  data: () => ({
    tab_selecionado: false,
    cabecalhos,
    produtos: [],
    pesquisa: '',
    carregando_dados: false,
    produtos_selecionados: [],
    dialog_ajuste_pedido: false,
    search: ''
  }),
  computed: {
    ...mapGetters({
      CONFIG_FORNECEDOR: "fornecedor/getConfig",
      FILTROS: "CompraProdutosGerais/getFiltros",
    }),
    CABECALHOS() {
      if (this.PEDIDO_SELECIONADO.idfornecedor === info_pedido_geral.idfornecedor) {
        return this.cabecalhos;
      }

      return this.cabecalhos.filter(item => item.value !== 'razao_social')
    },
    GET_TOTAL_PESO() {
      return this.produtos.reduce((a, b) => parseFloat(a) + parseFloat((b.peso * b.qtde_pedido) || 0), 0);
    },
    GET_TOTAL_CUBAGEM() {
      return this.produtos.reduce((a, b) => parseFloat(a) + parseFloat(((b.altura * b.comprimento * b.largura) * b.qtde_pedido) || 0), 0);
    },
    GET_TOTAL_PRECO_LIQUIDO() {
      return this.produtos.reduce((a, b) => parseFloat(a) + parseFloat((b.valor_liquido * b.qtde_pedido) || 0), 0);
    },
    TOTAL_SUGESTAO_EM_GALAO() {
      return this.produtos.reduce((a, b) => {
        const produto = { ...b, sugestao: b.qtde_pedido, tipo_litragem: this.CONFIG_FORNECEDOR.tipo_litragem };
        return calcular_sugestao_em_galao(produto) + a;
      }, 0);
    },
    COMPRA_EM_PALLET_COMPUTED() {
      return {
        qt_camandas: this.produtos.reduce((a, b) => {
          if (!Number(b.lastro_palete)) {
            return a;
          }

          return a + Number(b.qtde_pedido / Number(b.lastro_palete));
        }, 0),
        qt_pallet: this.produtos.reduce((a, b) => {
          if (!Number(b.lastro_palete) || !Number(b.altura_palete)) {
            return a;
          }

          return a + Number(b.qtde_pedido / (Number(b.lastro_palete) * Number(b.altura_palete)));
        }, 0)
      };
    }
  },
  watch: {
    PEDIDO_SELECIONADO: {
      handler() {
        this.produtos_selecionados = [];
        this.buscarProdutosPedidoSelecionado();
      },
      immediate: true
    },
    produtos: {
      handler() {
        this.$emit('update:produtos-pedido', this.produtos);
      },
      deep: true
    }
  },
  methods: {
    formatarNumero: formatarValor,
    formatarDinheiro: formatarValorMonetario,
    atualizarCarrinhoAjustePedido() {
      this.produtos_selecionados = [];
      this.buscarProdutosPedidoSelecionado();
    },
    buscarProdutosPedidoSelecionado() {
      if (!this.PEDIDO_SELECIONADO.idpedido) {
        return;
      }

      this.carregando_dados = true;
      this.produtos = [];

      const parametros = {
        idpedido: this.PEDIDO_SELECIONADO.idpedido
      }

      buscarProdutosPedidoSelecionado(parametros)
      .then(produtos => {
        this.produtos = produtos;
        this.carregando_dados = false;

        if (this.produtos.length === 0) {
          this.CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO();
        }

        this.produtos.map(item => {
          if (item.data_ultima_requisicao) {
            item.data_ultima_requisicao = item.data_ultima_requisicao.split('/').reverse().join('-');
          }
          if (item.data_ultima_entrada) {
            item.data_ultima_entrada = item.data_ultima_entrada.split('/').reverse().join('-');
          }
          return item;
        });
      })
      .catch(logout)
    },
    custoVsBase(i) {
      const custo = parseFloat(i.preco_custo || 0);
      const custoBase = parseFloat(i.preco_custo_base);

      return (i.preco_custo_base > 0)
        ? (custo / custoBase - 1) * 100
        : 0;
    },
    async excluirProdutos(produtos) {
      const parametros = {
        idpedido: this.PEDIDO_SELECIONADO.idpedido,
        produtos: arrayColumn(produtos, ['idproduto', 'idpedido'])
      };

      await this.$store.dispatch("loadingAux/habilitarLoading", true);

      await exluirProdutoDoCarrinho(parametros)
      .then(resposta => {
        this.produtos_selecionados = [];

        if (this.produtos.length === produtos.length) {
          this.CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO();
        } else {
          this.buscarProdutosPedidoSelecionado();
        }

        this.setResultadosApiExportacao(resposta);
      })
      .catch(logout)

      await this.$store.dispatch("loadingAux/habilitarLoading", false);
    },
    setResultadosApiExportacao({ resultado_exclusao_api_exportacao }) {
      if (resultado_exclusao_api_exportacao.sankhya) {
        const ev = {
          ...resultado_exclusao_api_exportacao.sankhya,
          callbackFn: this.excluirProdutos
        }

        this.$store.dispatch('ExportacaoPedidoCompraParaERP/resultado_exclusao_produto_sankhya', ev)
      }
    },
    abrirDialogExportacaoPedidoERP() {
      this.$store.dispatch('ExportacaoPedidoCompraParaERP/ativar_dialog_count')
    },
    classesCssLinha(linha) {
      return {
        'text-red': Number(linha.qtde_pedido) !== Number(linha.sugerido)
      }
    },
    getQtdePedidoEmbalagemMinimo(produto) {
      if (this.PEDIDO_SELECIONADO.emb_master === "N") {
        return parseFloat(produto.qtde_pedido);
      }

      if (produto.tipo_fator_conversao === 'D') {
        return parseFloat(produto.qtde_pedido) * parseFloat(produto.multiplo_compra);
      }

      return parseFloat(produto.qtde_pedido) / parseFloat(produto.multiplo_compra);
    },
    converterEmbalagemValorProduto(produto, valor) {
      if (this.PEDIDO_SELECIONADO.emb_master === "N") {
        return Number(valor);
      }

      if (produto.tipo_fator_conversao === 'D') {
        return Number(valor) / Number(produto.multiplo_compra);
      }

      return Number(valor) * Number(produto.multiplo_compra);
    },
    totalLinha(item) {
      const { preco_custo, qtde_pedido } = item;
      const RESULTADO = parseFloat(preco_custo) * parseFloat(qtde_pedido);

      return RESULTADO > 0 ? RESULTADO : 0;
    },
  }
}
</script>

<style scoped>
</style>
